import { Reducer } from "../../lib/redux";
import { IDefect } from "../../model/Defect";
import { extend } from "../../utils/vanilla";
import { DeviceDefectListActions, TrailerDefectListActions } from "./actions";
import { DeviceDefectListActionTypes, TrailerDefectListActionTypes } from "./types";

export let defaultDefectLists: IIdDictionary<IIdDictionary<IDefect[]>> = {};

export let deviceDefectLists: Reducer<IIdDictionary<IIdDictionary<IDefect[]>>, DeviceDefectListActions> = (state = defaultDefectLists, action) => {
        switch (action.type) {
            case DeviceDefectListActionTypes.SET_DEVICE_DEFECTLIST: {
                let userId = action.payload.userId;
                let defectLists = action.payload && action.payload.defectLists ? extend(true, {}, action.payload.defectLists) : {};
                if (userId) {
                    return {
                        ...state,
                        [userId]: defectLists
                    };
                }
                return state;
            }
            case DeviceDefectListActionTypes.CLEAR_DEVICE_DEFECTLIST: {
                const userId = action.payload && action.payload.userId;
                if (userId) {
                    let newState = { ...state };
                    delete newState[userId];
                    return newState;
                }
                return {};
            }
            default:
                return state;
        }
};

export let trailerDefectLists: Reducer<IIdDictionary<IIdDictionary<IDefect[]>>, TrailerDefectListActions> = (state = defaultDefectLists, action) => {
    switch (action.type) {
        case TrailerDefectListActionTypes.SET_TRAILER_DEFECTLIST: {
            let userId = action.payload && action.payload.userId;
            let defectLists = action.payload && action.payload.defectLists ? extend(true, {}, action.payload.defectLists) : {};
            if (userId) {
                return {
                    ...state,
                    [userId]: defectLists
                };
            }
            return state;
        }
        case TrailerDefectListActionTypes.CLEAR_TRAILER_DEFECTLIST: {
            const userId = action.payload && action.payload.userId;
            if (userId) {
                let newState = { ...state };
                delete newState[userId];
                return newState;
            }
            return {};
        }
        default:
            return state;
    }
};